import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.167 8.353a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.48 6.333a.5.5 0 0 1 .707 0L8.5 7.646l1.313-1.313a.5.5 0 0 1 .707.707L9.207 8.353l1.313 1.313a.5.5 0 0 1-.707.707L8.5 9.06l-1.313 1.313a.5.5 0 0 1-.707-.707l1.313-1.313L6.48 7.04a.5.5 0 0 1 0-.707"
    }, null, -1)
  ])))
}
export default { render: render }